<template>
  <v-container fluid>
    <div v-if="isCliente == 0">
      <v-row>
        <v-col>
            <v-toolbar dense color="#96298A" dark>
                <v-toolbar-title>Plantilla de Correo</v-toolbar-title><v-divider class="mx-2" vertical></v-divider>
                <v-toolbar-items>
                    <v-btn text link @click="dialog = true" color="#FC8333">Guía Aérea</v-btn><v-divider class="mx-2" vertical></v-divider>
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="#FC8333"
                            dark
                            text
                            v-bind="attrs"
                            v-on="on"
                        >
                            Encabezados
                        </v-btn>
                        </template>
                        <v-list>
                        <v-list-item                         
                        @click="insertElement('# ')"                           
                        >
                            <v-list-item-title><div class="text-h1">Encabezado 1</div></v-list-item-title>
                        </v-list-item>
                        <v-list-item                            
                        @click="insertElement('## ')"                           
                        >
                            <v-list-item-title><div class="text-h2">Encabezado 2</div></v-list-item-title>
                        </v-list-item>
                        <v-list-item             
                        @click="insertElement('### ')"                                          
                        >
                            <v-list-item-title><div class="text-h3">Encabezado 3</div></v-list-item-title>
                        </v-list-item>
                        <v-list-item             
                        @click="insertElement('#### ')"                                          
                        >
                            <v-list-item-title><div class="text-h4">Encabezado 4</div></v-list-item-title>
                        </v-list-item>
                        <v-list-item               
                        @click="insertElement('##### ')"                                        
                        >
                            <v-list-item-title><div class="text-h5">Encabezado 5</div></v-list-item-title>
                        </v-list-item>
                        <v-list-item                
                        @click="insertElement('###### ')"                                       
                        >
                            <v-list-item-title><div class="text-h6">Encabezado 6</div></v-list-item-title>
                        </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="#FC8333"
                            dark
                            text
                            v-bind="attrs"
                            v-on="on"
                        >
                            Insertar
                        </v-btn>
                        </template>
                        <v-list>
                        <v-list-item                         
                        @click="insertElement('--- ')"                           
                        >
                            <v-list-item-title>Linea (Division)</v-list-item-title>
                        </v-list-item>                        
                        </v-list>
                    </v-menu>
                    <v-divider vertical class="mx-4"></v-divider>                    
                    <v-btn text @click="dialogSave = true" dark>Guardar Plantilla</v-btn>
                    <v-btn text @click="enviarCorreo()" dark>Enviar Correo</v-btn>
                    
                </v-toolbar-items>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn                            
                            dark
                            text
                            v-bind="attrs"
                            v-on="on"
                        >
                            Plantillas Creadas
                        </v-btn>
                        </template>
                        <v-list>
                        <v-list-item                         
                        v-for="(plantilla, index) in listaPlantillas"
                        :key="index"                        
                        >
                            <v-list-item-title link @click="getPlantilla(plantilla)">{{plantilla}}</v-list-item-title>
                            <v-list-item-action>
                              <v-btn icon dark color="red" outlined @click="eliminarPlantilla(plantilla)">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </v-list-item-action>
                        </v-list-item>                        
                        </v-list>
                    </v-menu>
                </v-toolbar-items>
            </v-toolbar>
        </v-col>
      </v-row>      
      <div class="md">
        <v-row>
          <v-col cols="12" sm="6" md="6">
        <v-text-field label="Destinatarios :" @focus="handleFocus('destinatarios')" v-model="destinatarios"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field label="Asunto :" @focus="handleFocus('asunto')" v-model="asunto"></v-text-field>
          </v-col>
        </v-row>
        <div class="md-inner">          
          <v-textarea solo v-model="inputData" height="700px" ref="inputData" @focus="handleFocus('input')"></v-textarea>
          <div class="md-preview">
            <div class="md-subject" v-html="compiledDest"></div>
            <div class="md-subject" v-html="compiledSub"></div>
            <div class="md-content" v-html="compiledMarkdown"></div>
          </div>
        </div>
      </div>
      <v-dialog v-model="dialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="text-h5">Seleccionar Campo de Guía</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <json-viewer :value="guia" @keyclick="handlekk"></json-viewer>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogSave" persistent max-width="600px">
        <v-card>
          <v-card-title><span class="text-h5">Guardar Plantilla de Correo</span></v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field 
                v-model="nombrePlantilla"
                prepend-icon="mdi-file-edit"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined color="red" @click="dialogSave = false">Cancelar</v-btn>
            <v-btn outlined color="primary" @click="guardarPlantilla()">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-overlay :value="overlay">
        <waiting />
    </v-overlay>
    </div>
    <div v-else>
      <h1>Usted no tiene permisos para ver esta sección</h1>
    </div>
  </v-container>
</template>

<script>
import apicon from "../plugins/apicon";
import JsonViewer from "vue-json-viewer";
import MarkdownIt from "markdown-it";
import Waiting from "../components/Waiting.vue";
const md = new MarkdownIt({
  linkify: true,
  breaks: true,
});
export default {
  created: function () {},
  components: {
    JsonViewer,
    Waiting
  },
  props:{
    idGuia:{
      type: Number,
      default: 2548,
    },    
  },
  data() {
    return {
      overlay: false,
      focusedOn: '',      
      isCliente: 1,
      inputData: null,
      destinatarios: null,
      asunto: null,
      nombrePlantilla: null,
      dialog: false,
      dialogSave: false,
      guia: {},
      listaPlantillas: []
    };
  },
  computed: {
    compiledMarkdown() {
      return md.render(this.replaceVariables(this.inputData || ""));
    },
    compiledDest(){
      return md.render(this.replaceVariables(this.destinatarios || ""));
    },
    compiledSub(){
      return md.render(this.replaceVariables(this.asunto || ""));
    }
  },
  methods: {
    getData:async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "guias/" + this.idGuia)
        .then((result) => {                          
          this.guia = {
              'Fecha_Ingreso_AWB' :  new Date (new Date(result.created_at).toISOString().substring(0,10) + 'T00:00:00'),
              'Fecha_Pickup': result.fecha_pickup != null ? new Date(result.fecha_pickup + 'T00:00:00') : '',
              "Fecha_UNDEL": result.undel_fecha != null ? new Date(result.undel_fecha + 'T00:00:00') : '',
              "Motivo_UNDEL": result.motivosundellist.reduce((pv,cv) => pv + (cv.motivo != undefined ? cv.motivo.motivo : '') + (cv.observacion != null ? '(' + cv.observacion + '), ' : ','),""),                
              "Solución": result.undel_solucion,
              "Fecha_Solución": result.undel_fechasolucion,
              "Fecha_Salida": result.fecha_salida,
              "Fecha_Arribo": result.fecha_arribo != null ? new Date(result.fecha_arribo + 'T00:00:00') : '',
              "Fecha_Entrega": result.podfecha != null ? new Date(result.podfecha + 'T00:00:00') : '',
              "Persona_que_Recibio": result.podnombre,
              "PU_Reference_Schedule": result.pu_reference_shedule,
              "AWB_INEX": result.guia_interna,
              "Operador": result.proveedor,
              "AWB_Operador": result.guia_proveedor,
              "Via": result.via,
              "Facturar_a": result.clientefacturar != undefined ? result.clientefacturar.empresa: '',
              "Empresa_Receiver": result.empresa_c,
              "Contacto_Receiver": result.contacto_c,
              "Vat_Num_Receiver": result.nit_c,
              "Email_Receiver": result.correo_c,
              "Dirección_Receiver": result.direccion1_c + ' ' + result.direccion2_c + ' ' + (result.direccion3_c != null ? result.direccion3_c : ''),
              "Ciudad_Receiver": result.ciudad_c,
              "ZIP_Receiver": result.zip_c,
              "Teléfono_Receiver": result.telefono_c,
              "País_Receiver": result.pais_c,
              "Empresa_Sender": result.empresa_e,
              "Contacto_Sender": result.contacto_e,
              "Vat_Num_Sender": result.nit_e,
              "Email_Sender": result.correo_e,
              "Dirección_Sender": result.direccion1_e + ' ' + result.direccion2_e + ' ' + (result.direccion3_e != null ? result.direccion3_e : ''),
              "Ciudad_Sender": result.ciudad_e,
              "ZIP_Sender": result.zip_e,
              "Teléfono_Sender": result.telefono_e,
              "País_Sender": result.pais_e,
              "Descripción": result.descripcion,
              "Piezas": result.piezas,
              "Peso_kgs": result.peso,
              "Medidas_cm": result.paquetes.reduce((pv,cv) => pv + (cv.largo != null ? (cv.largo + 'X' + cv.ancho + 'X' + cv.alto + ',') : ''),""),
              "Valor_Declarado": result.valor,                
              "Moneda": result.moneda,
              "Incoterm": result.termino,
              "Referencia_del_Cliente": result.referencia_cliente,
              "Seguro": result.seguro,
              "Valor_Contenido": result.seg_valor_contenido,
              "Flete_Int": result.seg_flete_int,
              "Flete_Nac": result.seg_flete_nac,
              "Valor_Total_Seguro": result.seg_valor_total,
              "No_Aplicación": result.seg_no_aplicacion,
              'Cargos_Adicionales': result.cargosadicionales.reduce((pv, cv) => pv + cv.cargo.cargo + (cv.observacion != null ? '(' + cv.observacion + ')' : '') + '=$' + cv.valor + ', ' ,""),
              'Total_Cargos': result.cargosadicionales.reduce((sumv, itemv) => sumv + parseFloat(itemv.valor),0),
              "Régimen": result.regimen,  
              "Estatus": result.estatus != undefined ? result.estatus.descripcion : '',          
              "Arribo_en": result.arribo_en,     
              "Tipo_de_Persona": result.tipo_persona,
              "Origen": result.origen_per,
              "Cliente_Operador_Postal": result.cliente_operador_postal,
              "Reclamos": result.reclamoslst.reduce((pv,cv) => pv + (cv.causal != undefined ? cv.causal.causal : '') + (cv.estado != undefined ? '(' + cv.estado.estado + '),' : ''),""),
              "RPP_Peso": result.paquetes.reduce((sumv,itemv) => sumv + parseFloat(itemv.pesototal_r != null ? itemv.pesototal_r : 0),0),
              "RPP_Medidas": result.paquetes.reduce((pv,cv) => pv + (cv.largo_r != null ? (cv.largo_r + 'X' + cv.ancho_r + 'X' + cv.alto_r + ',') : ''),""),
              "Valor_Declarado_Aduana": result.valor_declarado_aduana,
              "Fecha_de_Envío_de_Datos_al_Agente": result.fecha_envio_datos_agente != null ? new Date(result.fecha_envio_datos_agente + 'T00:00:00') : '',
              "Fecha_de_Declaración": result.fecha_declaracion != null ? new Date(result.fecha_declaracion + 'T00:00:00') : '',
              "Fecha_de_Pago_de_Impuesto": result.fecha_pago_imp != null ? new Date(result.fecha_pago_imp + 'T00:00:00') : '',
              "Fecha_de_Liberación_Aduana": result.fecha_liberacion_aduana != null ? new Date(result.fecha_liberacion_aduana + 'T00:00:00') : '',
              "Observaciones": result.observaciones,
          }                    
        });
        Object.keys(this.guia).forEach((key) => {
          if(this.guia[key] === null){
            this.guia[key] = ''
          }
        })
    },
    handlekk(e) {
      switch (this.focusedOn) {
        case 'asunto':
          this.asunto != null ? this.asunto += e : this.asunto = e;
          break;
        case 'destinatarios':
          this.destinatarios != null ? this.destinatarios += e : this.destinatarios = e;
          break;
        case 'input':
          this.insertElement(e);
          break;
        default:
          break;
      }            
    },
    handleFocus: function(focused){
      this.focusedOn = focused;
    },
    insertElement:function(el){
        //this.inputData != null ? this.inputData += el : this.inputData = el;
        const textarea = this.$refs.inputData.$refs.input;
        const sentence = textarea.value;
        const len = sentence.length;
        let pos = textarea.selectionStart;
        if(pos === undefined){
          pos = 0;
        }
        const before = sentence.substr(0,pos);
        const after = sentence.substr(pos,len);
        this.inputData = before + el + after;
        
        this.$nextTick().then(() => {
          textarea.selectionStart = pos + el.length;
        });

        //this.$refs.inputData.focus();
    },
    replaceVariables(input) {
      let lookup = this.guia || {};
      let updated = input;

      Object.keys(lookup).forEach((key) => {
        updated = updated.replace("$.", "");
        updated = updated.replace("00:00:00 GMT-0600 (GMT-06:00)","");
        updated = updated.replace("00:00:00 GMT-0500 (GMT-05:00)","");
        updated = updated.replace(
          new RegExp("\\b" + key + "\\b", "g"),
          lookup[key]
        );
        //updated = updated.replace(key, lookup[key]);
      });

      return updated;
    },
    guardarPlantilla: function(){
      if(this.nombrePlantilla != null){
        let fileName = this.nombrePlantilla + ".txt";
        let contents = this.inputData;
        let subject = this.asunto;
        let to = this.destinatarios;
        apicon.saveDataApi(apicon.getApiBaseUrl() + 'guardarplantilla',{name: fileName, contents: contents,subject : subject, to : to}).then((result) => {
          if(result){
            this.inputData = null;
            this.asunto = null;
            this.destinatarios = null;
            this.nombrePlantilla = null;
            this.getListaPlantillas();
            this.dialogSave = false;
            this.$swal("Plantilla almacenada!");
          }else{
            this.$swal("No se pudo guardar la plantilla");
          }
        });
      }else{
        this.$swal("Por favor ingrese un nombre a la plantilla");
      }      
    },
    eliminarPlantilla: function(nombre){
      var self = this;
      this.$swal(this.dswalEliminar).then((resultdlg) => {
        if (resultdlg.value) {
          apicon.saveDataApi(apicon.getApiBaseUrl() + 'eliminarplantilla',{name: nombre}).then((result) => {
            if(result){
              this.$swal("Plantilla eliminada!");
              self.getListaPlantillas();
            }else{
              this.$swal("Error al eliminar plantilla")
            }
          })
        }
      });        
    },
    getListaPlantillas: function(){
      apicon.getDataApi(apicon.getApiBaseUrl() + 'listaplantillas').then((result) => {
        this.listaPlantillas = result;
      });
    },
    getPlantilla: function(nombre){
      apicon.saveDataApi(apicon.getApiBaseUrl() + 'getplantilla',{nombre: nombre}).then((result) => {
        this.inputData = result.contents;
        this.nombrePlantilla = nombre.replace('.txt','');
        this.destinatarios = result.to;
        this.asunto = result.subject;
      });
    },
    enviarCorreo:async function(){
      this.overlay = true;
      await apicon.saveDataApi(apicon.getApiBaseUrl() + 'enviarcorreo', {
        email_to : this.replaceVariables(this.destinatarios || ''),
        subject : this.replaceVariables(this.asunto || ''),
        message : this.compiledMarkdown
      }).then((result) => {
        if(result){
          this.$swal(result.message)
          this.overlay = false;
        }
      }).catch((err) => {
        this.$swal(err)
        this.overlay = false;
      }).finally(() => {
        this.overlay = false;
      });
    },    
  },
  mounted() {
    apicon.setAuthHeaders();
    this.isCliente = localStorage.getItem("cliente");
    this.getData();
    this.getListaPlantillas();
  },
};
</script>

<style lang="scss" scoped>
$box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
* {
  box-sizing: border-box;
}

html {
  width: 100%;
  height: 100%;
}

.ft {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  color: #222;
  font-family: helvetica;
  -webkit-font-smoothing: antialiased;
  font-size: 10px;
  line-height: 16px;
}
.md {
  height: 100%;
  padding: 35px 50px;
  &-inner {
    height: 100%;
    box-shadow: $box-shadow;
    display: flex;
    flex-wrap: wrap;
  }
  &-btn {
    text-align: right;
  }
  &-editor {
    padding: 25px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    width: 50%;
    background: #fff;
    overflow-y: scroll;
  }
  &-preview {
    padding: 25px;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    width: 50%;
    background: #f2f2f2;
    overflow-y: scroll;
  }
  &-subject {
    font-size: 16px;
    line-height: 16px;
    padding-bottom: 15px;
  }
  &-content {
    font-size: 16px;
    line-height: 25px;
    padding: 25px;
    background: #fff;
    img {
      display: block;
      width: 35%;
      margin: 0 auto;
    }
    h1 {
      text-align: center;
      margin-bottom: 30px;
    }
  }
}
</style>